import Tool from './Tool';
import Shortcut from '../utils/Shortcut';

class ToolSendToBack extends Tool {
  static toolName = 'Send to back';
  static shortcut = new Shortcut('pagedown,Cmd+[');

  static action({ controller, selection }) {
    selection.sendToBack();
    this.toolActionComplete({ controller });
  }

  static available({ controller, selection }) {
    if (selection?.type === 'comment') {
      return false;
    }

    return super.available({ controller, selection });
  }
}

export default ToolSendToBack;
